import { setBearerToken, setUserData } from '@/common/axios';
import {
  ENDPOINT_SET_PLATFORM_TYPE,
  MODAL_KEYS,
  PlatformTypeEnum,
  ROUTE_LOADS,
} from '@/common/constants';
import { HttpApi } from '@/common/http/HttpApi';
import Modal from '@/common/modal/Modal';
import { Button } from '@/components/ui/button';
import { useModal } from '@/hooks/useModal';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { CropSelectionProps } from '../models';

const httpApi = new HttpApi();

export const CropSelection = ({ sessionData }: CropSelectionProps) => {
  const { t } = useTranslation();
  const { closeModal } = useModal(MODAL_KEYS.CROP_SELECTION);
  const navigate = useNavigate();

  const { mutate: setPlatformType, isLoading } = useMutation({
    mutationFn: (cropType: PlatformTypeEnum | string) =>
      httpApi.put(
        ENDPOINT_SET_PLATFORM_TYPE,
        { platform_type: cropType },
        {
          headers: {
            Authorization: `Bearer ${sessionData?.id}`,
          },
        },
      ),
    onSuccess: (res) => {
      setBearerToken(res?.session_id);
      setUserData(res?.session_id);
      navigate(ROUTE_LOADS);
      closeModal();
    },
  });

  return (
    <Modal
      onClose={closeModal}
      modalKey={MODAL_KEYS.CROP_SELECTION}
      title={t('select.crop') as string}
    >
      <div className="flex flex-col gap-3 mt-6 pb-1">
        <Button
          isLoading={isLoading}
          onClick={() => setPlatformType(PlatformTypeEnum.COTTON)}
          className="w-full h-11 bg-[#14044D] hover:bg-[#14044D]/90 text-white text-sm font-medium tracking-wide rounded-xl transition-all duration-200"
        >
          {t('cotton')}
        </Button>

        <div className="flex items-center gap-4">
          <div className="h-px flex-1 bg-gray-100" />
          <span className="text-[11px] tracking-widest text-gray-300 uppercase">
            {t('or')}
          </span>
          <div className="h-px flex-1 bg-gray-100" />
        </div>

        <Button
          isLoading={isLoading}
          onClick={() => setPlatformType(PlatformTypeEnum.GRAIN)}
          className="w-full h-11 bg-[#F07006] hover:bg-[#F07006]/90 text-white text-sm font-medium tracking-wide rounded-xl transition-all duration-200"
        >
          {t('grain')}
        </Button>
      </div>
    </Modal>
  );
};
